import axios from "axios";

export default function requestApi(endpoint, method, body = [], responseType = 'json', contentType = 'application/json') {
    const headers = {
        "Accept": "application/json",
        "Content-Type": contentType,
        "Access-Control-Allow-Origin": "*",
        "X-Role": "user"
    };

    const instance = axios.create({ headers });

    return instance.request({
        method: method,
        url: `${process.env.REACT_APP_API_ORIGIN}${endpoint}`,
        data: body,
        responseType: responseType
    })
}

export function buildQuery(params) {
    return '?' + Object.keys(params)
        .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
}
